import React, {FC, useEffect, useMemo, useState} from 'react';
import {
    DateCellItem,
    daysOfTheWeek, formatDate,
    getCurrentMothDays,
    getDaysAmountInAMonth, getFridayForCell, getNextMonthDays, getNumDaySelected,
    getPreviousMonthDays, isAvailableCell, isBiggerThanDate,
    isInRange, isPrevMonAv, isSmallerThanDate, isSutSun,
    isToday, isUsed, isWeekEnd,
    months
} from "./utils";
import {clsx} from "clsx";
import {label} from "../../../service";
import {CalType} from "../../../page/Bike";


type InitialValue ={
    start:string,
    end:string
}

interface DatePickerPopupContentProps {
    selectedValue: Date;
    onSelect: (value: string[], duration: number) => void,
    denyDays:Date[],
    usedDays?:Date[],
    type:CalType,
    minDay?:number,
    maxDay?:number,
    initialValue?:InitialValue
}

export const DataPickerContent: FC<DatePickerPopupContentProps> = ({selectedValue,
                                                                       onSelect,denyDays:recDenyDays,
                                                                       usedDays=[],type,
                                                                       minDay,maxDay,
                                                                      initialValue}) => {


    const denyDays = useMemo(()=>{
         if(!usedDays){
             return recDenyDays;
         }
         return [...recDenyDays,...usedDays]
    },[recDenyDays,usedDays]);

    const apiDates = ["2026-05-25", "2026-05-26", "2026-05-27", "2026-05-28", "2026-05-29"];
    const dropOffOnlyDays = apiDates.map(dateStr => new Date(dateStr));

    const [startSelect, setStartSelect] = useState(false);
    const [min, setMin] = useState<Date>();
    const [max, setMax] = useState<Date>();
    const [start,setStart] = useState<Date>();
    const [panelYear, setPanelYear] = useState(() => selectedValue.getFullYear());
    const [panelMonth, setPanelMonth] = useState(() => selectedValue.getMonth());
    const todayDate = useMemo(() => {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    }, []);
    const [year, month, day] = useMemo(() => {
    const currentYear = selectedValue.getFullYear();
    const currentDay = selectedValue.getDate();
    const currentMonth = selectedValue.getMonth();
    return [currentYear, currentMonth, currentDay];
    }, [selectedValue]);

    useEffect(()=>{
        setMin(undefined);
        setMax(undefined);
        setStart(undefined);
        setStartSelect(false);
    },[type])

    useEffect(()=>{
        if(initialValue){
            const start = new Date(initialValue.start);
            const end = new Date(initialValue.end);
            setPanelMonth(start.getMonth());
            setMin(start);
            setMax(end);
        }
    },[])

    const dateCells = useMemo(() => {
        const daysInAMonth = getDaysAmountInAMonth(panelYear, panelMonth);
        const currentMonthDays = getCurrentMothDays(panelYear, panelMonth, daysInAMonth);
        const prevMonthDays = getPreviousMonthDays(panelYear, panelMonth);
        const nextMonthDays = getNextMonthDays(panelYear, panelMonth);
        return [...prevMonthDays, ...currentMonthDays, ...nextMonthDays];
    }, [panelYear, panelMonth]);

    const firstDenyDayAfterStart = useMemo(() => {
        if (!start) return null;
        const futureDenyDays = denyDays
            .filter(d => d.getTime() > start.getTime())
            .sort((a, b) => a.getTime() - b.getTime());
        return futureDenyDays.length > 0 ? futureDenyDays[0] : null;
    }, [start, denyDays]);

    const nextMonth = () => {
        if (panelMonth === 11) {
            setPanelMonth(0);
            setPanelYear(panelYear + 1);
        } else {
            setPanelMonth(panelMonth + 1);
        }
    };

    const prevMonth = () => {
        if (panelMonth === 0) {
            setPanelMonth(11);
            setPanelYear(panelYear - 1);
        } else {
            setPanelMonth(panelMonth - 1);
        }
    };

    const onMouseEnter = (item: DateCellItem) => {
        if (startSelect && start) {
            const curEnter = new Date(item.year, item.month, item.date);

            if (isSmallerThanDate(curEnter, start)) {
                return;
            }

            if (firstDenyDayAfterStart && isBiggerThanDate(curEnter, firstDenyDayAfterStart)) {
                return;
            }

            if (maxDay && getNumDaySelected(start, curEnter) > maxDay) {
                return;
            }

            setMax(curEnter);
        }
    }

    const onDateSelect = (item: DateCellItem) => {
        if(isUsed(item,denyDays)){
            return;
        }
        const cellDate = new Date(item.year, item.month, item.date);
        const isDropOffOnly = dropOffOnlyDays.some(d =>
            d.getDate() === item.date &&
            d.getMonth() === item.month &&
            d.getFullYear() === item.year
        );

        switch (type) {
            case "half": {
                if (isDropOffOnly) {
                    return;
                }

                setMin(cellDate);
                setMax(cellDate);
                onSelect([formatDate(cellDate),formatDate(cellDate)],1);
                return;
            }
            case "weekend": {
                let isUsedCell = isUsed(item,denyDays,true);
                if(isUsedCell){
                    return;
                }
                const fridayDate = getFridayForCell(item);
                const isFridayDropOffOnly = dropOffOnlyDays.some(d =>
                    d.getDate() === fridayDate.getDate() &&
                    d.getMonth() === fridayDate.getMonth() &&
                    d.getFullYear() === fridayDate.getFullYear()
                );
                if (isFridayDropOffOnly) {
                    return;
                }
                const day = cellDate.getDay();
                let localMin, localMax;
                switch (day){
                    case 5:
                        localMin =(cellDate);
                        localMax= (new Date(item.year, item.month, item.date+3));
                        break;
                    case 6:
                        localMin =(new Date(item.year, item.month, item.date-1));
                        localMax=(new Date(item.year, item.month, item.date+2));
                        break;
                    case 0:
                        localMin =(new Date(item.year, item.month, item.date-2));
                        localMax=(new Date(item.year, item.month, item.date+1));
                        break;
                }
                if(localMin && localMax){
                    setMin(localMin);
                    setMax(localMax);
                    onSelect([formatDate(localMin),formatDate(localMax)],2);
                }
                return;
            }
            default: {
                if (!startSelect) {
                    if (isDropOffOnly) {
                        return;
                    }

                    setStartSelect(true);
                    setStart(cellDate);
                    setMin(cellDate);
                    setMax(cellDate);
                }
                else {
                    if (!start) return;

                    const isSameDay = cellDate.getDate() === start.getDate() &&
                        cellDate.getMonth() === start.getMonth() &&
                        cellDate.getFullYear() === start.getFullYear();

                    if (isSameDay) {
                        setStartSelect(false);
                        setMax(cellDate);
                        onSelect(
                            [formatDate(start), formatDate(cellDate)],
                            1
                        );
                        return;
                    }


                    if (isSmallerThanDate(cellDate, start)) {
                        return;
                    }

                    if (firstDenyDayAfterStart && isBiggerThanDate(cellDate, firstDenyDayAfterStart)) {
                        return;
                    }

                    const duration = getNumDaySelected(start, cellDate);

                    if (minDay && duration < minDay) return;
                    if (maxDay && duration > maxDay) return;

                    setStartSelect(false);
                    setMax(cellDate);

                    onSelect(
                        [formatDate(start), formatDate(cellDate)],
                        duration
                    );
                }
                return;
            }
        }
    };

    let isPrevMon = isPrevMonAv(panelMonth, panelYear, year, month);

    return (
        <div className="CalendarPanel">
            <div className="CalendarPanel__header">
                <div className="CalendarPanel__buttons">
                    <div className="CalendarPanel__buttons-left">
                        {isPrevMon && <div className={"btn btn-secondary"} onClick={prevMonth}>{"<"}</div>}
                    </div>
                    <div className="CalendarPanel__date" data-testid="date-picker-popup-month">
                        {label(months[panelMonth])} {panelYear}
                    </div>
                    <div className="CalendarPanel__buttons-right">
                        <div className={"btn btn-secondary"} onClick={nextMonth}>{">"}</div>
                    </div>
                </div>
            </div>
            <div className="CalendarPanel__content">
                {daysOfTheWeek.map(weekDay => (
                    <div key={weekDay} className="CalendarPanelItem dayWeekItem">{label(weekDay)}</div>
                ))}
                {dateCells.map(cell => {
                    const isTodayDate = isToday(cell, todayDate);
                    const isNotCurrent = cell.type !== 'current';
                    let isUsedCell = isUsed(cell,denyDays,type==="weekend") ;
                    if (type === "weekend" && !isUsedCell) {
                        isUsedCell = !isWeekEnd(cell);
                    }
                    if (type === "half" && !isUsedCell) {
                        isUsedCell = isSutSun(cell);
                    }
                    let isDateInRange = isInRange(
                        new Date(cell.year, cell.month, cell.date),
                        new Date(year, month, day),
                    );
                    const cellDate = new Date(cell.year, cell.month, cell.date);
                    const dayOfWeek = cellDate.getDay();
                    const isPastDay = cellDate.getTime() < todayDate.getTime();
                    const isCellDropOffOnly = dropOffOnlyDays.some(d =>
                        d.getDate() === cell.date &&
                        d.getMonth() === cell.month &&
                        d.getFullYear() === cell.year
                    );
                    if (isPastDay) {
                        isDateInRange = false;
                    }
                    let isWeekendFridayBlocked = false;
                    if (type === "weekend" && (dayOfWeek === 5 || dayOfWeek === 6 || dayOfWeek === 0)) {
                        const associatedFriday = getFridayForCell(cell);
                        isWeekendFridayBlocked = dropOffOnlyDays.some(d =>
                            d.getDate() === associatedFriday.getDate() &&
                            d.getMonth() === associatedFriday.getMonth() &&
                            d.getFullYear() === associatedFriday.getFullYear()
                        );
                    }
                    if (type === "half" && isCellDropOffOnly) {
                        isDateInRange = false;
                    }
                    if (type === "weekend" && isWeekendFridayBlocked) {
                        isDateInRange = false;
                    }


                    if (startSelect && start) {
                        if (isSmallerThanDate(cellDate, start)) {
                            isDateInRange = false; // Назад идти нельзя
                        }
                        if (firstDenyDayAfterStart && isBiggerThanDate(cellDate, firstDenyDayAfterStart)) {
                            isDateInRange = false; // Сквозь чужую бронь идти нельзя
                        }
                    }


                    if(isUsedCell){
                        isDateInRange = false;
                    }
                    const isSelected = isUsedCell?false:isInRange(new Date(cell.year, cell.month, cell.date),min,max);
                    const isAvailableSelect = isAvailableCell(startSelect,maxDay?maxDay:0,denyDays,cell,min);
                    const usedMe = isUsed(cell,usedDays);
                    const isStart = start && cell.date === start.getDate() && cell.month === start.getMonth() && cell.year === start.getFullYear();
                    const className = clsx(
                        'CalendarPanelItem',
                        isTodayDate && 'CalendarPanelItem--selected CalendarPanelItem--today',
                        isNotCurrent && 'CalendarPanelItem--not-current',
                        !usedMe && !isUsedCell && !isDateInRange && !(startSelect && isStart) && 'CalendarPanelItem--not-in-range',
                        isSelected && 'CalendarPanelItem--in',
                        isUsedCell && 'CalendarPanelItem--used',
                        isAvailableSelect && 'CalendarPanelItem--available',
                        usedMe && 'CalendarPanelItem--used-me',
                        ((type === "normal" && isCellDropOffOnly && !startSelect) ||
                            (type === "half" && isCellDropOffOnly) ||
                            (type === "weekend" && isWeekendFridayBlocked))
                            ? 'CalendarPanelItem--drop-off-disabled'
                            : (type === "normal" && isCellDropOffOnly && startSelect)
                                ? 'CalendarPanelItem--drop-off-active'
                                : null
                    );

                    return (
                        <div
                            className={className}
                            key={`${cell.date}-${cell.month}-${cell.year}`}
                            onClick={() => {
                                const isClickingStartDay = startSelect && isStart;
                                if (isPastDay) {
                                    return;
                                }
                                if (type === "half" && isCellDropOffOnly) {
                                    return;
                                }
                                if (type === "weekend" && isWeekendFridayBlocked) {
                                    return;
                                }
                                if (isDateInRange || isClickingStartDay || !startSelect) {
                                    onDateSelect(cell);
                                }
                            }}
                            onMouseEnter={() => {
                                onMouseEnter(cell)
                            }}
                        >
                            <div className="CalendarPanelItem__date">{cell.date}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

